import { isNil } from 'lodash';
import { moment } from '@/utility';

export default {
  methods: {
    convertDateToMoment(value, timezoneOffset) {
      const offset = timezoneOffset || 0;
      return moment.isMoment(value) ? value : moment.utc(value).add(offset, 'h');
    },
    formatDate(value, timezoneOffset) {
      if (isNil(value)) return null;
      return this.convertDateToMoment(value, timezoneOffset).format('L');
    },
    formatDateTime(value, timezoneOffset) {
      if (isNil(value)) return '-';
      return this.convertDateToMoment(value, timezoneOffset).format('YYYY-MM-DD HH:mm:ss');
    },
    formatPickerDate(value, timezoneOffset) {
      return this.convertDateToMoment(value, timezoneOffset).format('YYYY-MM-DD');
    },
    formatPickerTime(value) {
      return moment(value, 'HH:mm:ss');
    },
  },
};
